export const data = {
  menuOpen: false,
};
